export default {"src":"/_next/static/media/logo-light.7939d296.svg","height":130,"width":400,"blurWidth":0,"blurHeight":0};